import { FC } from "react";
import styled from "styled-components";
import { ConsentIndexResource } from "../types/consent";
import { CheckboxConsent } from "./CheckboxConsent";

const Consents = styled.div`
	display: grid;
	grid-auto-rows: max-content;
	gap: ${({ theme }) => theme.spacing(4)};
	padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

interface Props {
	consents: ConsentIndexResource[];
	name?: string;
}

export const ConsentFormFields: FC<Props> = ({ consents, name }) => (
	<Consents>
		{consents.map((consent) => (
			<CheckboxConsent key={consent.id} consent={consent} name={name ? `${name}.${consent.id}` : `${consent.id}`} />
		))}
	</Consents>
);
